module.exports = __webpack_public_path__ + "img/violoncello-cerimonia.ded9e1bc.jpg";